import { render } from "./datagrid-odata-crud.vue?vue&type=template&id=4bfa0f6f"
import script from "./datagrid-odata-crud.vue?vue&type=script&lang=js"
export * from "./datagrid-odata-crud.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__